import _ from "lodash";
import React, { useEffect } from "react";
import { InformationFilled } from "@toddle-edu/ds-icons";
import { RadioButton, Tooltip } from "@toddle-edu/ds-web";

import { useI18n } from "Hooks";

import { EXAM_SESSION_TIMEZONES } from "../EditOrgInfo/components/CurriculumOptions/modules/CurriculumOptionsUtils";

import classes from "./TimezoneComp.scss";

const styles = {
  overlayInnerStyle: { width: 164, textAlign: "center" },
};

const TimezoneComp = props => {
  const {
    examSessionMonth,
    updateOrgObject,
    examSessionTimezone,
    examSessionTimezoneFromQuery,
  } = props;

  const { t } = useI18n(["onBoarding"]);

  const updatedTimezone = _.isEmpty(examSessionTimezoneFromQuery)
    ? _.get(_.first(EXAM_SESSION_TIMEZONES), "label")
    : examSessionTimezoneFromQuery;

  useEffect(() => {
    if (_.includes(["MAY", "NOVEMBER"], examSessionMonth)) {
      updateOrgObject({
        examSessionTimezone: updatedTimezone,
      });
    }
  }, [examSessionMonth, updatedTimezone]);

  return (
    <div className={classes.container}>
      <div className={classes.headerContainer}>
        <div className={classes.headerText}>
          {t("onBoarding:select_timezone_for_your_school")}
        </div>
        <Tooltip
          tooltip={t(
            "onBoarding:imported_grade_boundaries_exam_session_and_timezone"
          )}
          overlayInnerStyle={styles.overlayInnerStyle}
        >
          <InformationFilled variant="subtle" />
        </Tooltip>
      </div>
      <div className={classes.timezoneOptionContainer}>
        {_.map(EXAM_SESSION_TIMEZONES, ({ regions, label, id }) => {
          return (
            <div
              key={id}
              className={classes.timezoneOption}
              onClick={() => {
                updateOrgObject({ examSessionTimezone: label });
              }}
            >
              <RadioButton checked={label === examSessionTimezone} />
              <div className={classes.timezoneOptionTextContainer}>
                <div className={classes.headerText}>{`${t(
                  "onBoarding:timezone"
                )} ${id} (${label})`}</div>
                <div className={classes.timezoneSubText}>{regions}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TimezoneComp;
